<smrts-page [tabTitle]="titulo">

  <div header class="header inline-element">
    <h1 #overflow="smrtsOverflowDetector" smrtsOverflowDetector class="primary-color page-title"
    [matTooltip]="titulo" [matTooltipDisabled]="!overflow.truncado">{{ titulo }}</h1>

    <a routerLink="/painel-financeiro" mat-icon-button matTooltip="Voltar" class="accent-color btn-voltar">
      <mat-icon>arrow_back</mat-icon>
    </a>

    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <button *hasPermission="permissaoImportarExtrato" mat-raised-button matTooltip="Importar extrato" (click)="importExtrato.click()" class="btn-importar btn-acao-header">
      <mat-icon>upload_file</mat-icon>
      <span class="btn-acao-label">Importar Extrato</span>
    </button>

    <input #importExtrato type="file" class="display-none"
      [accept]="historicoConciliacao.tipoContaBanco === tipoContaBancoCartao ? csvFileType : excelFileType"
      (change)="importLancamentos(importExtrato)">

      <a [disableNoPermission]="permissaoEditarConciliacao" [routerLink]="'/conciliacao/'+historicoConciliacao.contaBancoId" class="accent-color btn-acao-header" mat-raised-button
        matTooltip="Nova conciliação">
        <mat-icon>add</mat-icon>
        <span class="btn-acao-label">Nova Conciliação</span>
      </a>

      <button class="accent-color" mat-icon-button [matMenuTriggerFor]="menuMaisOpcoes" matTooltip="Mais opções">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menuMaisOpcoes="matMenu" xPosition="before">
        <button mat-menu-item class="inline-element accent-color" [disableNoPermission]="permissaoEditarConciliacao" (click)="reconciliarLancamentosClick()">
          <mat-icon class="accent-color">sync</mat-icon>
          Reconciliar lançamentos
        </button>
        <button mat-menu-item class="inline-element accent-color" [disableNoPermission]="permissaoDesfazerImportacao" (click)="desfazerImportacaoClick()">
          <mat-icon class="accent-color">undo</mat-icon>
          Desfazer importação
        </button>
      </mat-menu>
    </div>

    <div class="content">
      <mat-card>
        <div class="table-container">
          <p-table [value]="historicoConciliacao.conciliacoes" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Último extrato importado</th>
                <th>Nº lançamentos em aberto</th>
                <th>Diferença</th>
                <th>Saldo</th>
                <th>Caixa</th>
                <th>Valor Lançamentos em Aberto</th>
                <th>Criação da conciliação</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-element let-rowIndex="rowIndex">
              <tr [pSelectableRow]="element" [pSelectableRowIndex]="rowIndex" class="table-row">
                <td>{{ element.dataUltimoLancamentoBanco | date:'dd/MM/yyyy' }}</td>
                <td>{{ element.numLancamentosAbertos }}</td>
                <td>{{ element.diferenca | currency:'BRL' }}</td>
                <td>{{ element.saldo | currency:'BRL' }}</td>
                <td>{{ element.valorNoCaixa | currency:'BRL' }}</td>
                <td>{{ element.valorLancamentosAbertos | currency:'BRL' }}</td>
                <td>{{ element.dataCriacao | date:'dd/MM/yyyy' }}</td>
                <td>
                  <div class="inline-element acoes-linha">
                    <a [routerLink]="'/conciliacao/editar/'+element.id" class="accent-color" mat-icon-button>
                      @if (rowIndex === 0 && podeEditarConciliacao) {
                        <mat-icon matTooltip="Editar conciliação">edit</mat-icon>
                      }
                      @if (rowIndex !== 0 || !podeEditarConciliacao) {
                        <mat-icon matTooltip="Visualizar conciliação">visibility</mat-icon>
                      }
                    </a>
                    <button class="accent-color" mat-icon-button [matMenuTriggerFor]="menuConciliacao">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>

                  <mat-menu #menuConciliacao="matMenu" xPosition="before">
                    <button mat-menu-item [disableNoPermission]="permissaoExportarConciliacao" (click)="exportarConciliacao(rowIndex)">Exportar Conciliação</button>
                  </mat-menu>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </mat-card>
    </div>

  </smrts-page>